import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';


const HeroSliderHome = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slidesData = [
    {
      id: 1,
      title: "Marketplace",
      buttonText: "Shop Now",
      link: "/marketplace",
      image: "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/a0e3c2cd-5a4d-43fd-21be-5d0ff6ac6e00/public",
    },
    {
      id: 2,
      title: "Discover Quality",
      buttonText: "Explore",
      link: "/marketplace",
      image: "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/923f02be-f536-4034-ce69-61577eb94700/public",
    },
    {
      id: 3,
      title: "New Arrivals",
      buttonText: "New Collection",
      link: "/marketplace",
      image: "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/2d6181cc-105c-4b10-a93b-6c02369d1600/public",
    },
    {
      id: 4,
      title: "Join the Tribe",
      buttonText: "Join Now",
      link: "/marketplace",
      image: "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/05acfe7a-d1dd-48e5-8e2e-825061354b00/public",
    },
    {
      id: 5,
      title: "Exclusive Offers",
      buttonText: "Get Offers",
      link: "/marketplace",
      image: "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/283dc1c3-5c62-4bae-b341-94559a16ef00/public",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval); 
  }, [currentSlide]); 

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slidesData.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slidesData.length) % slidesData.length);
  };

  return (
    <div className="homepage-hero-slider home-page-hero-compact">
      {slidesData.map((slide, index) => (
        <div
          key={slide.id}
          className={`homepage-hero-slide ${index === currentSlide ? 'homepage-hero-slide-active' : 'homepage-hero-slide-inactive'}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          {index === currentSlide && (
            <div className="homepage-hero-slide-content">
              <h1 className="homepage-hero-slide-title">{slide.title}</h1>
              <Link to={slide.link} className="homepage-hero-slide-button">
                {slide.buttonText}
              </Link>
            </div>
          )}
        </div>
      ))}
      <button className="homepage-hero-slider-button homepage-hero-slider-button-left" onClick={prevSlide}>
        <ChevronLeftIcon className="homepage-hero-icon" />
      </button>
      <button className="homepage-hero-slider-button homepage-hero-slider-button-right" onClick={nextSlide}>
        <ChevronRightIcon className="homepage-hero-icon" />
      </button>
    </div>
  );
};

export default HeroSliderHome;


